import { ChangeEvent, useEffect, useState } from "react";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "dayjs/locale/es.js";
import axios from 'axios';
import moment from "moment";
import toast from 'react-hot-toast';
import SearchIcon from '@mui/icons-material/Search';
import { Box, Button, Grid, InputAdornment } from "@mui/material";
import { Calendar, ToolbarProps, dayjsLocalizer, momentLocalizer, } from "react-big-calendar";
import CalenderComponentStyle from "./CalendarComponentStyles";
import ModalComponents from '../modalComponents/ModalComponents'
import LeftArrowIcon from "../../assets/icons/left-arrow.svg";
import RightArrowIcon from "../../assets/icons/right-arrow.svg";
import CalenderStyle from "../../pages/calendar/CalendarStyle";
import EventDetailsModal from "../../modals/eventDetailModal/EventDetailsModal";
import { DeleteModal } from "../../modals/deleteModal/DeleteModal";
import InputFieldComponent from '../inputField/InputFieldComponent';
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";

moment.locale("en", {
  week: {
    dow: 1, // Monday is the first day of the week
  },
});


const CustomToolbar = ({ label, onNavigate }: ToolbarProps) => {
  // To change the months of calendar
  const goToBack = () => {
    onNavigate("PREV");
  };

  const goToNext = () => {
    onNavigate("NEXT");
  };

  return (
    <Box>
      <Button onClick={goToBack} sx={{ ...CalenderComponentStyle.buttonStyle }}>
        <img
          src={LeftArrowIcon}
          alt="Tets"
          style={{ height: "24px", width: "24px" }}
        />
      </Button>
      <label style={{ ...CalenderComponentStyle.mainTitleTypo }}>{label}</label>
      <Button onClick={goToNext} sx={{ ...CalenderComponentStyle.buttonStyle }}>
        <img
          src={RightArrowIcon}
          alt="Tets"
          style={{ height: "24px", width: "24px" }}
        />
      </Button>
    </Box>
  );
};

const CalendarComponent = () => {
  const { t } = useTranslation();
  const [allEvents, setAllEvents] = useState<AllEvents[]>([]);
  const [searchValue, setSearchValue] = useState("");
  const [showEventDetailOpen, setShowEventDetailOpen] =
    useState<boolean>(false);
  const [deleteCalenderOpen, setDeleteCalenderOpen] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [selectedEvent, setSelectedEvent] = useState<AllEvents>()
  const [calendarEvent, setCalendarEvent] = useState<any[]>([])
  const [filteredCalendarEvent, setFilteredCalendarEvent] = useState<any[]>([])

  const currentLanguage = localStorage.getItem(
    "language"
  );

  const localizer =
    currentLanguage === "spanish"
      ? dayjsLocalizer(dayjs)
      : momentLocalizer(moment);

  useEffect(() => {
    currentLanguage === "spanish" && dayjs.locale("es");
  }, [currentLanguage]);

  useEffect(() => {
    fetchAllEvent();
  }, []);


  useEffect(() => {
    if (calendarEvent) {
      const trimmedSearchValue = searchValue.trim();
      const filteredEvents: AllEvents[] = calendarEvent.filter(event =>
        event.title.toLowerCase().includes(trimmedSearchValue.toLowerCase())
      );
      setFilteredCalendarEvent(filteredEvents);
    }
  }, [searchValue, calendarEvent]);

  const fetchAllEvent = async () => {
    try {
      let destructRes: CalendarEvent[] = [];
      const response = await axios.get("http://localhost:4200/eventsData");
      if (response.data) {
        response.data.map((detail: AllEvents) => {
          destructRes.push({
            title: detail.title,
            start: new Date(detail?.start),
            end: new Date(detail?.end),
            id: detail.id,
          });
        });
        setCalendarEvent(destructRes)
      }
      setAllEvents(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleEventClick = (event: AllEvents) => {
    setShowEventDetailOpen(true)
    const newEvent = allEvents.find((data) => data.id === event.id)
    setSelectedEvent(newEvent)
  };

  const handleCloseEvent = () => {
    setShowEventDetailOpen(false)
  }

  const handleDeleteEvent = (id: string | undefined) => {
    setIsLoading(true)
    axios
      .delete(`http://localhost:4200/eventsData/${id}`)
      .then(() => {
        toast.error(t("toastMsg.eventDelete"))
        fetchAllEvent()
        setDeleteCalenderOpen(false)
        setIsLoading(false)
      })
      .catch((error) => {
        setIsLoading(false)
        console.error("Error deleting event:", error);
      });
  };

  return (
    <Box>
      <Box
        className="main-header-box tab-mobile-wrap tab-mobile-wrap-table"
        {...CalenderComponentStyle.mainTableHeaderBox}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={8} lg={8} xl={6} {...CalenderComponentStyle.firstGridItem}>
            <InputFieldComponent
              label=""
              type="text"
              placeHolder={t("homePage.search")}
              sx={{ ...CalenderStyle.searchInputSx }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              onChange={(e: ChangeEvent<HTMLInputElement>) => {
                setSearchValue(e.target.value);
              }}
            />
          </Grid>
        </Grid>
      </Box>
      <Calendar
        className="my-calendar"
        selectable
        localizer={localizer}
        events={filteredCalendarEvent}
        startAccessor="start"
        endAccessor="end"
        popup={true}
        style={CalenderComponentStyle.calenderStyleHeight}
        views={["month"]}
        components={{
          toolbar: CustomToolbar,
        }}
        onSelectEvent={handleEventClick}
        eventPropGetter={() => ({
          style: CalenderComponentStyle.calenderPropGetter,
        })}
      />
      <ModalComponents
        open={showEventDetailOpen}
        modelTitleTopPadding="3px 8px 0px 8px"
      >
        <EventDetailsModal
          setDeleteCalenderOpen={() => {
            setDeleteCalenderOpen(true);
            setShowEventDetailOpen(false);
          }}
          handleClose={() => handleCloseEvent()}
          eventData={selectedEvent}
        />
      </ModalComponents>

      <ModalComponents
        open={deleteCalenderOpen}
        handleClose={() => setDeleteCalenderOpen(false)}
        title={t("deleteModal.deleteTitle")}
      >
        <DeleteModal
          deleteTitle={t("deleteModal.deleteMsg")}
          handleClose={() => setDeleteCalenderOpen(false)}
          eventName="contentDelete"
          handleDelete={() => handleDeleteEvent(selectedEvent?.id)}
          deleteDisabled={isLoading}
        />
      </ModalComponents>
    </Box>
  );
};

export default CalendarComponent;
